import React from 'react';

import { Box, Flex, Link, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import {
  linksSection,
  linksWrapper,
  linkTextWrapper,
  linkWrapper,
} from './styles';

const Links = () => {
  const { t } = useTranslation();

  return (
    <Flex css={linksWrapper} id="links">
      <Box>
        <Typography variant="caption" css={linkTextWrapper}>
          &copy;{new Date().getFullYear()} project44
        </Typography>
      </Box>
      <Flex css={linksSection} gap="small">
        <Typography variant="caption" css={linkTextWrapper}>
          <Link css={linkWrapper} href="https://project44.com/terms/">
            {t('loginFooter.termsAndConditions')}
          </Link>
        </Typography>
        <Typography variant="caption" css={linkTextWrapper}>
          <Link css={linkWrapper} href="https://project44.com/support/">
            {t('loginFooter.supportPortal')}
          </Link>
        </Typography>
        <Typography variant="caption" css={linkTextWrapper}>
          <Link css={linkWrapper} href="https://project44.com/privacy/">
            {t('loginFooter.privacyPolicy')}
          </Link>
        </Typography>
      </Flex>
    </Flex>
  );
};

export default Links;
